import React from 'react';
import { muiPasswordShow, muiPasswordHide } from '@ally/metronome-icons';
import { useAriaLive } from '@ally/use-aria-live';
import { useAdornmentState, usePasswordMaskAdornment } from '../context';
export var usePasswordMask = function (_a) {
    var onClick = _a.onClick;
    var _b = usePasswordMaskAdornment(), isMasked = _b.isMasked, setMasked = _b.setMasked, inputValue = _b.inputValue, setMaskRef = _b.setMaskRef;
    var _c = useAdornmentState(), isBlurred = _c.isBlurred, inputRef = _c.inputRef, onBlurRelatedTarget = _c.onBlurRelatedTarget;
    var announceAssertive = useAriaLive().announceAssertive;
    var handleToggleMask = function (e) {
        var _a, _b;
        if (isMasked) {
            announceAssertive("Your password is ".concat(inputValue));
        }
        else {
            announceAssertive("Your password is hidden");
        }
        setMasked(!isMasked);
        (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var handleBlurMask = function (e) {
        var isInput = e.relatedTarget === inputRef.current;
        if (!isMasked && !isInput)
            setMasked(true);
    };
    var maskRef = React.useRef(null);
    React.useEffect(function () {
        setMaskRef(maskRef);
    }, []);
    React.useEffect(function () {
        var isMaskButton = onBlurRelatedTarget === maskRef.current;
        if (isBlurred && !isMaskButton)
            setMasked(true);
    }, [isBlurred, onBlurRelatedTarget]);
    return {
        variant: 'custom',
        position: 'right',
        item: {
            ref: maskRef,
            variant: 'interactive',
            'aria-label': isMasked ? 'show password' : 'hide password',
            'data-testid': 'mui-password-mask-adornment',
            onClick: handleToggleMask,
            onBlur: handleBlurMask,
            icon: {
                icon: isMasked ? muiPasswordShow : muiPasswordHide,
                fill: 'slate-4',
            },
        },
    };
};
//# sourceMappingURL=usePasswordMask.js.map